import { useQuery } from '@tanstack/react-query';
import { useSelectedClinicId } from '@hooks/useSelectedClinicId';
import {
    getActualOnDayLegalEntityId,
    legalEntityBranchQueryOptions,
} from '@organization/queries/legalEntityBranchQueries';

interface SelectedLegalEntity {
    legalEntityId?: string;
    isLoaded: boolean;
    isError: boolean;
}

export function useSelectedLegalEntityId(): SelectedLegalEntity {
    const { selectedClinicId, isLoaded: isClinicLoaded, isError: isClinicError } = useSelectedClinicId();
    const branchesQuery = useQuery(legalEntityBranchQueryOptions.byOrganizationId(selectedClinicId));

    const isLoaded = isClinicLoaded && (!selectedClinicId || branchesQuery.data !== undefined);

    return {
        legalEntityId: branchesQuery.data ? getActualOnDayLegalEntityId(branchesQuery.data, new Date()) : undefined,
        isLoaded,
        isError: isClinicError || branchesQuery.isError,
    };
}
